import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";
import { useTranslation } from "react-i18next";

function View(_props) {
  const { t } = useTranslation("dashboard");
  return (
    <main className="settings">
      <SettingsNav />

      <div className="Content">{t("settings.landingPage")}</div>
    </main>
  );
}

const Settings = (app) => {
  app.get("/", set("heading", "Settings"), ({ res }) => {
    res.body = <View />;
  });
};

export default Settings;
